import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { ifasColors } from "../../ifas/components/OperationsUI";

const SwitchWrapper = styled(Box)(({ theme }) => ({
  width: "370px",
  height: "40px",
  backgroundColor: ifasColors.page,
  borderRadius: "10px",
  padding: "4px",
  display: "flex",
  position: "relative",
  justifyContent: "space-between",
  alignItems: "center",
  border: `1px solid ${ifasColors.border}`,
  marginLeft: "20px",
  [theme.breakpoints.down("md")]: {
    width: "300px",
    marginLeft: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginLeft: 0,
  },
}));

const SwitchButton = styled(Box)({
  flex: 1,
  height: "100%",
  zIndex: 1,
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  padding: "0 4px",
});

const Slider = styled("div")({
  position: "absolute",
  top: 4,
  bottom: 4,
  borderRadius: "10px",
  backgroundColor: ifasColors.surface,
  transition: "all 0.3s ease",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
});

export type HistoryTab = { value: string; label: string; onSelect?: () => void };

const HistoryTabSwitch = ({
  selectedTab,
  setSelectedTab,
  tabs,
}: {
  selectedTab: string;
  setSelectedTab: (value: string) => void;
  tabs: HistoryTab[];
}) => {
  const activeIndex = Math.max(
    tabs.findIndex((tab) => tab.value === selectedTab),
    0,
  );
  const widthPercent = 100 / tabs.length;

  return (
    <SwitchWrapper>
      <Slider
        style={{
          left: `calc(${activeIndex * widthPercent}% + 4px)`,
          width: `calc(${widthPercent}% - 8px)`,
        }}
      />

      {tabs.map((tab) => (
        <SwitchButton
          key={tab.value}
          onClick={() => {
            setSelectedTab(tab.value);
            tab.onSelect?.();
          }}
        >
          <Typography
            variant="body2"
            sx={(theme) => ({
              color:
                selectedTab === tab.value
                  ? ifasColors.orange
                  : ifasColors.muted,
              fontWeight: selectedTab === tab.value ? 800 : 600,
              fontSize: 15,
              whiteSpace: "nowrap",
              [theme.breakpoints.down("md")]: { fontSize: 13 },
              [theme.breakpoints.down("sm")]: { fontSize: 12 },
            })}
          >
            {tab.label}
          </Typography>
        </SwitchButton>
      ))}
    </SwitchWrapper>
  );
};

export default HistoryTabSwitch;
